import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsItFor() {
  return <section className="py-16 md:py-24 bg-[#0d0d0d]" data-id="element-245">
      <div className="max-w-5xl mx-auto px-4" data-id="element-246">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-247">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4" data-id="element-248">
            ¿Para Quién Es Esto?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-249">
          {/* YES Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#151515] p-5 md:p-8 rounded-2xl border-t-4 border-cyan-500 shadow-lg" data-id="element-250">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-5 md:mb-8 flex items-center gap-3" data-id="element-251">
              <span className="bg-cyan-500/20 p-2 rounded-full text-cyan-400" data-id="element-252">
                <CheckCircle2 size={20} data-id="element-253" />
              </span>
              Esto es para ti si:
            </h3>
            <ul className="space-y-4 md:space-y-6" data-id="element-254">
              {['Tienes 35+ y sientes que tu energía, foco o recuperación no son como antes.', 'Has intentado otras soluciones pero nada parecía durar.', 'Quieres un plan claro y realista, sin extremos.'].map((item, i) => <li key={i} className="flex gap-3 md:gap-4 text-sm md:text-base text-gray-300" data-id="element-255">
                  <CheckCircle2 className="text-cyan-500 shrink-0 mt-0.5" size={18} data-id="element-256" />
                  <span data-id="element-257">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* NO Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#151515] p-5 md:p-8 rounded-2xl border-t-4 border-red-500 shadow-lg" data-id="element-258">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-5 md:mb-8 flex items-center gap-3" data-id="element-259">
              <span className="bg-red-500/20 p-2 rounded-full text-red-400" data-id="element-260">
                <XCircle size={20} data-id="element-261" />
              </span>
              Esto NO es para ti si:
            </h3>
            <ul className="space-y-4 md:space-y-6" data-id="element-262">
              {['Buscas una "cura milagrosa" sin hacer cambios.', 'Quieres resultados sin seguir el plan de 7 días.', 'Necesitas tratamiento médico para una condición específica (esto es educación y hábitos).'].map((item, i) => <li key={i} className="flex gap-3 md:gap-4 text-sm md:text-base text-gray-300" data-id="element-263">
                  <XCircle className="text-red-500 shrink-0 mt-0.5" size={18} data-id="element-264" />
                  <span data-id="element-265">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}